export default __webpack_public_path__ + "static/media/1050.5cedf0e3.png";